import React from "react";
import { Modal, ModalProps } from "antd";
import { ReactNode } from "react";
import { IoCloseOutline } from "react-icons/io5";

interface MeshBillModalProps extends ModalProps {
  headerStyle?: React.CSSProperties;
  closeIcon?: ReactNode;
  children?: ReactNode;
  title: string;
  titleImage?: string | any;
}
const MeshBillModal: React.FC<MeshBillModalProps> = ({
  headerStyle,
  closeIcon,
  children,
  title,
  titleImage,
  ...rest
}) => {
  const titleContent = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...headerStyle,
      }}
    >
      {titleImage && (
        <img src={titleImage} alt="Title" style={{ marginRight: "10px" }} />
      )}
      {title}
    </div>
  );
  return (
    <Modal
      {...rest}
      wrapClassName="meshbill-modal"
      closeIcon={
        closeIcon || <IoCloseOutline className="modal-close-icon-customized" />
      }
      title={titleContent}
      footer={null}
      keyboard={false}
      maskClosable={false}
    >
      {children}
    </Modal>
  );
};
export default MeshBillModal;
